import { useEffect, useState, type ReactElement } from "react";
import { useNavigate } from "react-router-dom";

import { getIdToken } from "../lib/auth";

/**
 * Route guard. If there's no id_token in sessionStorage, redirects to /.
 * Token freshness/expiry is NOT verified client-side — the API gateway's JWT
 * authorizer is the source of truth. If the API ever 401s, the api wrapper
 * will surface it.
 */
export default function RequireAuth({ children }: { children: ReactElement }) {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!getIdToken()) {
      navigate("/", { replace: true });
    } else {
      setReady(true);
    }
  }, [navigate]);

  return ready ? children : null;
}
